export enum SiteAdminInvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
}
